import { memo, useCallback } from 'react';
import FilterConjunction from './filterItem/FilterConjunction.jsx';
import FilterContent from './filterItem/FilterContent.jsx';
import FilterItemActions from './filterItem/FilterItemActions.jsx';

const FilterRow = memo(({ filter, index, dataSource, isTransformAction, isIfElse, lookupSettings, item, fieldOptions, operatorOptions, isAdvanced, customOperators, useDynamicFields, canUseManualFieldEntry, onUseManualFieldEntry, onConjunctionChange, onFilterChange, onAdd, onAddGroup, onDelete, onToggleDisabled, loading, reload }) => {
  const handleDelete = useCallback(() => onDelete(filter?.id), [onDelete, filter?.id]);
  const handleToggleDisabled = useCallback(() => onToggleDisabled(filter?.id), [onToggleDisabled, filter?.id]);

  return (
    <div className={`filter-row ${filter?.disabled ? 'disabled' : ''}`}>
      <div className="filter-row-content">
        <FilterConjunction item={item} filter={filter} index={index} isAdvanced={isAdvanced} onChange={onConjunctionChange} />
        <FilterContent dataSource={dataSource} isTransformAction={isTransformAction} isIfElse={isIfElse} lookupSettings={lookupSettings} filter={filter} fieldOptions={fieldOptions} operatorOptions={operatorOptions} isAdvanced={isAdvanced} customOperators={customOperators} useDynamicFields={useDynamicFields} canUseManualFieldEntry={canUseManualFieldEntry} onUseManualFieldEntry={onUseManualFieldEntry} onConjunctionChange={onConjunctionChange} onFilterChange={onFilterChange} onAdd={onAdd} onAddGroup={onAddGroup} onDelete={onDelete} onToggleDisabled={onToggleDisabled} loading={loading} reload={reload} />
        <div className="filter-row-actions">
          <FilterItemActions //
            onDelete={handleDelete}
            onToggleDisabled={handleToggleDisabled}
            isDisabled={filter?.disabled}
          />
        </div>
      </div>
    </div>
  );
});

FilterRow.displayName = 'FilterRow';

const FilterItem = ({ dataSource, isTransformAction, lookupSettings, item, fieldOptions, operatorOptions, isAdvanced = false, isIfElse = false, customOperators = false, useDynamicFields = false, canUseManualFieldEntry = false, onUseManualFieldEntry, onConjunctionChange, onFilterChange, onAdd, onAddGroup, onDelete, onToggleDisabled, loading, reload }) => {
  const filterSet = item?.filterSet || [];

  return (
    <div className="filter-item">
      {filterSet?.map((filter, index) => (
        <FilterRow //
          key={`${filter?.id}-${index}`}
          filter={filter}
          index={index}
          dataSource={dataSource}
          isTransformAction={isTransformAction}
          isIfElse={isIfElse}
          lookupSettings={lookupSettings}
          item={item}
          fieldOptions={fieldOptions}
          operatorOptions={operatorOptions}
          isAdvanced={isAdvanced}
          customOperators={customOperators}
          useDynamicFields={useDynamicFields}
          canUseManualFieldEntry={canUseManualFieldEntry}
          onUseManualFieldEntry={onUseManualFieldEntry}
          onConjunctionChange={onConjunctionChange}
          onFilterChange={onFilterChange}
          onAdd={onAdd}
          onAddGroup={onAddGroup}
          onDelete={onDelete}
          onToggleDisabled={onToggleDisabled}
          loading={loading}
          reload={reload}
        />
      ))}
    </div>
  );
};

export default memo(FilterItem);
